<template>
  <el-dialog title="企微报警策略" :visible.sync="dialogVisible" width="640px">
    <div class="policy-status-row">
      <span class="policy-label">策略状态</span>
      <el-select v-model="status" style="width: 160px">
        <el-option :value="1" label="开启"></el-option>
        <el-option :value="0" label="关闭"></el-option>
      </el-select>
    </div>
    <div v-for="(group, index) in groups" :key="index" class="policy-group">
      <div class="policy-group-head">
        <span>标签组 {{ index + 1 }}</span>
        <el-button type="text" v-if="canDeleteGroup" @click="removeGroup(index)">删除</el-button>
      </div>
      <el-select v-model="group.labels" multiple collapse-tags filterable placeholder="请选择标签" style="width: 100%">
        <el-option v-for="item in labelOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </div>
    <el-button type="text" :disabled="groups.length >= 10" @click="addGroup">＋ 新增标签组</el-button>
    <div class="policy-hint">可配置多组标签；当质检数据命中任一标签组（组内标签需全部命中），且状态=已确认/仅提醒时，通过企微应用消息提醒一线客服。</div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getQwAiQualityWecomPolicyApi, saveQwAiQualityWecomPolicyApi } from '@/api/qwAiQuality';

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialogVisible: false,
      status: 1,
      groups: [],
    };
  },
  computed: {
    labelOptions() {
      return this.options.labels || [];
    },
    canDeleteGroup() {
      return !(this.status === 0 && this.groups.length === 1);
    },
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.fetchPolicy();
    },
    async fetchPolicy() {
      const data = await getQwAiQualityWecomPolicyApi();
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.status = data.data.status;
      this.groups = (data.data.groups || []).map(group => ({ group_no: group.group_no, labels: group.labels || [] }));
    },
    addGroup() {
      if (this.groups.length >= 10) {
        this.$message.warning('标签组最多可配置10条');
        return;
      }
      this.groups.push({ group_no: this.groups.length + 1, labels: [] });
    },
    removeGroup(index) {
      this.groups.splice(index, 1);
      this.groups.forEach((group, i) => {
        group.group_no = i + 1;
      });
    },
    async save() {
      if (this.status === 1 && this.groups.length === 0) {
        this.$message.warning('策略状态开启时，至少配置一个标签组');
        return;
      }
      const data = await saveQwAiQualityWecomPolicyApi({ status: this.status, groups: this.groups });
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('保存成功');
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
.policy-status-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #edf1f5;
}
.policy-label {
  font-weight: 700;
  color: #606a78;
}
.policy-group {
  border: 1px solid #e6ebf2;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 12px;
}
.policy-group-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  font-weight: 700;
  color: #263447;
}
.policy-hint {
  margin-top: 10px;
  color: #8792a2;
  line-height: 1.6;
}
</style>
